<template>
    <v-container class="py-5 px-5" fluid v-if="this.$store.state.signedIn">
        <v-layout justify-center wrap>
            <v-flex xs12 md8 class="px-2 py-2">
                <v-toolbar color="secondary" dark>
                    <v-toolbar-title :style="$store.state.textFormatting.headers">
                        Search a prefix to view its disaggregation history
                    </v-toolbar-title>
                    <v-progress-circular indeterminate color="blue" v-if="loading">
                    </v-progress-circular>
                    <v-spacer></v-spacer>
                    <info>
                        <template>
                            Disaggregation History
                        </template>

                        <template slot="body">
                            <p> Disaggregation events occur when an ASN advertises a prefix which is <b>more or less specific</b> than an already existing advertised prefix. (ranging from <b>/8 to /32</b> in IPv4, <b>/8 to /128</b> in IPv6) </p>
                            <p> <b>Example</b>: If I search for <b>1.1.1.0/24</b>, and <b>AS 1</b> has advertised ownership of <b>1.1.1.1/32</b>, this will appear in the graph / table. Similarly, if <b>AS 2</b> advertises ownership of <b>1.1.0.0/16</b>, this will also appear in the graph / table. </p>
                            <br />
                            <b> Disaggregation history is stored for the duration of the database's existence (i.e. back to April 2019) </b>
                            <br />
                            <p> The legend in the graph below will only display if there are less than 10 ASNs involved </p>
                            <br />
                            <v-divider />
                            <br />
                            <p> <b>Difference between Disaggregation and Prefix routing</b></p>
                            <p> <b>Disaggregation</b>: Looks at the assertion level of the system (prior to events being created), to see when any 
                                <b>parent</b> or <b>child</b> prefix has had it's ownership asserted over. It may or may not have created an event,
                                hence doesn't tie directly to the events created in the system.
                            </p>
                            <p> <b>Prefix routing</b>: Looks only at the prefix of interest, and at the event level of the system (once events <b>have</b> been created).
                                These will therefore have a direct link to the events in the system and can therefore be inspected via the website.
                            </p>
                        </template>
                    </info>
                </v-toolbar> 
                <v-card>
                    <v-card-text>
                        <v-form>
                            <v-layout>
                                <v-flex xs12>
                                    <v-text-field :style="$store.state.textFormatting.main" v-model="InputPrefix4" :rules="pre_rules" @keyup.enter.prevent="apiresponsechart(InputPrefix4)" label="Prefix" required></v-text-field>
                                    <v-text-field class="hidden" v-model="potato" label="not a thing" v-show="false" />
                                </v-flex>
                                
                                
                                <v-flex>
                                    <v-btn :style="$store.state.textFormatting.main" color="green" dark 
                                        @click.prevent="apiresponsechart(InputPrefix4)"
                                        > Submit</v-btn>
                                    
                                </v-flex>
                            </v-layout>
                            
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-flex>
            <v-flex xs12 class="px-2 py-2">
                <v-card v-if="ShowGraphAndTableInDOM">
                    <v-toolbar color="secondary" dark>
                        <v-toolbar-title :style="$store.state.textFormatting.headers">
                            Results for {{ searchedPrefix }}
                        </v-toolbar-title>
                    </v-toolbar>
                    <v-flex xs12 >
                        <v-layout justify-center>
                            <v-flex xs12 md6 class="px-2 py-2 chart-container" >
                                <v-card>
                                    <v-card-text>
                                        <scat-chart :chart-data="scatdata2" :options="options"></scat-chart> 
                                    </v-card-text>
                                </v-card>
                            </v-flex>
                            <v-flex xs12 md6 class="px-2 py-2">
                                <v-data-table :headers="headers" :items="disagdata" :key="id" 
                                    :rows-per-page-items="rowsPerPageItems" :pagination.sync="pagination" v-if="table_buffer">
                                    <template slot="headerCell" slot-scope="props">
                                        <v-tooltip top eager>
                                        <span slot="activator" :style="$store.state.textFormatting.main" class="text-xs-center">
                                            {{ props.header.text }}
                                        </span>
                                        <span :style="$store.state.textFormatting.main">
                                            {{ props.header.ad_text }}
                                        </span>
                                        </v-tooltip>
                                    </template>
                                    <template slot="items" slot-scope="props">
                                        <tr>
                                            <td class="text-xs-center special" :style="$store.state.textFormatting.main">
                                                <v-tooltip top eager color="primary" v-if="asn_own_dict[props.item.origin_asn]">
                                                    <template v-slot:activator="{ on }">
                                                        <div v-on="on" :style="$store.state.textFormatting.main">{{ props.item.origin_asn }}</div>
                                                    </template>
                                                    <span :style="$store.state.textFormatting.main"> {{ asn_own_dict[props.item.origin_asn] }}</span>
                                                </v-tooltip>
                                                <div v-if="!asn_own_dict[props.item.origin_asn]" :style="$store.state.textFormatting.main"> {{ props.item.origin_asn }} <v-progress-circular size="12" indeterminate color="purple" /></div>
                                            </td>
                                            <td class="text-xs-center special" :style="$store.state.textFormatting.main">
                                                <v-tooltip top eager color="primary" v-if="asn_own_dict[props.item.peer_asn]">
                                                    <template v-slot:activator="{ on }">
                                                        <div v-on="on" :style="$store.state.textFormatting.main">{{ props.item.peer_asn }}</div>
                                                    </template>
                                                    <span :style="$store.state.textFormatting.main"> {{ asn_own_dict[props.item.peer_asn] }}</span>
                                                </v-tooltip>
                                                <div v-if="!asn_own_dict[props.item.peer_asn]" :style="$store.state.textFormatting.main"> {{ props.item.peer_asn }} <v-progress-circular size="12" indeterminate color="purple" /></div>
                                            </td>
                                            <!--<td class="text-xs-center" :style="$store.state.textFormatting.main"> {{ props.item.message_type }}</td>-->
                                            <td class="text-xs-center" :style="$store.state.textFormatting.main"> {{ props.item.prefix}}</td>
                                            <td class="text-xs-center" :style="$store.state.textFormatting.main"> {{ props.item.observation_time.date }}</td>
                                            <td class="text-xs-center" :style="$store.state.textFormatting.main"> {{ props.item.observation_time.time }}</td>
                                        </tr>
                                    </template>
                                </v-data-table>       
                            </v-flex>
                            <v-flex xs12 md6 v-if="ShowNoData" class="px-2 py-2">
                                <v-card>
                                    <v-card-text>
                                        <h3 :style="$store.state.textFormatting.main"> BGP Spotlight has not processed any messages for this prefix  </h3>
                                    </v-card-text>
                                </v-card>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-card>
            </v-flex>
            
        </v-layout>
    </v-container>
</template>

<script>

//import BarChart from '../../shared/operational/BarChart.js'
import ScatChart from '../../shared/operational/scatter-graph.js'
//import LineChart from '../../shared/developing/line-graph.js'
import { API, graphqlOperation } from 'aws-amplify';
import info from '../../shared/operational/infopopout.vue'
import { findParentComponentByName } from '../utils/findParent.js'
import { isValidPrefix } from '../../shared/operational/validations.js'

export default {
    name: 'dissag',
    description: 'Connecting to a REST API which is being hosted on an EC2 box. This page is designed to allow the user to query prefixes where they believe a disaggregation event has occured.',
    components: {
        ScatChart,
        info
    },
    data () {
        return  {
            rowsPerPageItems: [20, 30, 40, 50],
            pagination: {
                rowsPerPage: 20
            },
            ShowGraphAndTableInDOM: false,
            vType: 'v4',
            ShowNoData: false,
            loading: false,
            InputPrefix4: "",
            searchedPrefix: "",
            pre_rules: [ isValidPrefix ],
            headers: [
                { text: 'Origin ASN', value:'origin_asn', align: 'centre', ad_text: 'ASN originating the given prefix'},
                { text: 'Peer ASN', value:'peer_asn', align: 'centre', ad_text: 'ASN we see the announcement from'},
                //{ text: 'Type', value:'type' },
                { text: 'Prefix', value:'prefix', align:'centre', ad_text: 'Prefix of the announcement'},
                { text: 'Date', value:'observation_time.epoch', align:'centre', ad_text: 'Date'},
                { text: 'Time', value:'observation_time.epoch', align:'centre', ad_text: 'Time'},
                
                ],
            isThereALabel: false,
            disagdata: [],
            options: {
                //responsive: true,
                //maintainAspectRatio: false,
                //height: 900,
                tooltips: {
                    titleFontSize: this.$store.state.textFormatting.traceroute.fontSize + 10, 
                    bodyFontSize: this.$store.state.textFormatting.traceroute.fontSize + 10,
                    callbacks: {
                        label: function(tooltipItem, data) {

                            var label;
                            var dataPointEpochTimeInHRFormat = new Date (data.datasets[tooltipItem.datasetIndex].data[0].x *1000)
                            label = "Time/Date: " + dataPointEpochTimeInHRFormat.toLocaleString() || 'No time Given';

                            var ListofPrefixs = ""
                            for (var i = 0; i < data.datasets[tooltipItem.datasetIndex].data.length; i=i+1) {
                                if (data.datasets[tooltipItem.datasetIndex].data[i].x == tooltipItem.xLabel &&
                                data.datasets[tooltipItem.datasetIndex].data[i].index.split('/')[1] == tooltipItem.yLabel) {
                                    ListofPrefixs += data.datasets[tooltipItem.datasetIndex].data[i].index +", "
                                }
                            }
                            label += "    Prefixes: " + ListofPrefixs
                            
                            if (data.datasets[tooltipItem.datasetIndex].label != "Withdraw") {
                                label += "    Origin ASN: " + data.datasets[tooltipItem.datasetIndex].label                             
                            } else {
                                label += "    Origin ASN: No Origin ASN"         
                            }

                            return label;
                        }
                    }
                },
                pan: {
                    enabled: true,
                    mode: 'x',
                    passive: true
                },
                zoom: {
                    enabled: true,
                    mode: 'x',
                    passive: true
                },
                title: {
                    display: true,
                    text: '',
                    fontSize: 16
                },
                legend: {
                    position: 'bottom',
                    labels: {
                        fontSize: this.$store.state.textFormatting.traceroute.fontSize + 10, 
                    },
                },
                scales: {
                    yAxes: [{
                        scaleLabel: {
                            display: true,
                            labelString: 'Subnet',
                            fontSize: this.$store.state.textFormatting.traceroute.fontSize + 10
                        },
                        ticks: {
                            min: 8,
                            max: 32,
                            fontSize: this.$store.state.textFormatting.chart.axis_label
                        }
                    }],
                    xAxes: [{
                        scaleLabel: {
                            display: true,
                            labelString: 'Time',
                            fontSize: this.$store.state.textFormatting.traceroute.fontSize + 10
                        },
                        ticks: {
                            fontSize: this.$store.state.textFormatting.chart.axis_label,
                            callback: (value, index, values) => {
                                var dataPointEpochTimeInHRFormat = new Date (value *1000);
                                let dateTime = dataPointEpochTimeInHRFormat.toLocaleString().split(", ");
                                return dateTime[0].split("/")[0] + "/" + dateTime[0].split("/")[1] + " " + dateTime[1].split(":")[0] + ":" + dateTime[1].split(":")[1];  
                            }
                        }
                    }]
                },
                
                },
                id: 1,
                scatdata2: [],
                sampleDataSet: {datasets: [
                    {
                        label: 'Scatter Dataset 1',
                        fill: false,
                        borderColor: '#f87979',
                        backgroundColor: '#f87979',
                        data:   [
                                { x: -2, y: 4 }, 
                                { x: -1, y: 1 },
                                { x: 0, y: 0 }, 
                                { x: 1, y: 1 }, 
                                { x: 2, y: 4 }]
                    }
                ]
            },
            asn_own_dict: {},
            asn_get_owner: [],
            table_buffer: true,
            potato: '',
            disag_events: false,
            send_disag: false

        }
        
    },
    beforeMount () {

        let app = findParentComponentByName(this, 'app')
        app.checkSignedIn()

        if (this.$route.params.prefix) {
            var pre = String(this.$route.params.prefix);
            console.log(pre)

            this.InputPrefix4 = pre;
        } else {
            if (this.$store.state.searches.disag) {
                this.InputPrefix4 = this.$store.state.searches.disag
            }
        }
    },
    methods: {
        runDatSelecta: async function () {
            this.apiresponsechart(this.InputPrefix4)
        },
        disagShard: async function (pre_str, event_time, n) {
            try {
                //console.log("starting shard " + n.toString());
                var query =
                `query getDisagEvents {
                    getDisagEvents (
                    pre_str: "` +
                pre_str +
                `",
                    event_time: ` +
                event_time +
                `,
                    hours_back: ` +
                n +
                `
                    ) {
                    prefix 
                    origin_asn_new
                    origin_asn_old
                    time_exact
                    time_5min
                    peer_asn
                    }  
                }`;
                const queryRes = await API.graphql(graphqlOperation(query));

                this.awaited += 1;

                //console.log(queryRes)
                if (queryRes.data.getDisagEvents) {
                //console.log(queryRes.data.getDisagEvents)
                return queryRes.data.getDisagEvents;
                } else {
                return [];
                }
            } catch (err) {
                console.log(err);
                return [];
            }
            },
        getDisagData: async function () {
            try {
                this.disag_events = [];
                this.awaited = 0;
                this.send_disag = false;
                var hours_to_go = 48;
                var prefixes_combined = "";
                for (var i = 0; i < this.disag_prefixes.length; i++) {
                if (i != 0) {
                    prefixes_combined += ",";
                }
                prefixes_combined += "'";
                prefixes_combined += this.disag_prefixes[i];
                prefixes_combined += "'";
                }
                console.log("PREFIX STR : " + prefixes_combined.length.toString());
                var to_run = [];
                for (var i = 0; i < hours_to_go; i++) {
                to_run.push(
                    this.disagShard(
                    prefixes_combined,
                    this.currentEpisodeData[0].time_5min,
                    i
                    )
                );
                }

                var all_events = [];
                var results = [];

                for (var i = 0; i < hours_to_go; i++) {
                results.push(await to_run[i]);
                /*console.log(events.length.toString() + " events " + i.toString())
                for (var i = 0 ; i < events.length ; i++ ) {
                    all_events.push(events[i])
                }*/
                }

                //console.log(results)
                for (var i = 0; i < hours_to_go; i++) {
                for (var j = 0; j < results[i].length; j++) {
                    all_events.push(results[i][j]);
                }
                }

                //console.log(all_events.length.toString() + " (all events)");
                this.disag_events = all_events;

                if (this.awaited == hours_to_go) {
                    console.log("ALL SHARDS DONE");
                    this.send_disag = true;
                }
                console.log(this.disag_events);
                console.log("ALL DONE");
            } catch (err) {
                console.log(err);
            }
        },
            
        
        createTableDataForDisAgInfo: function (disagInfo) {
            var asnList = []
            for (var x = 0; x< disagInfo.length; x = x+1) {
                asnList.push(disagInfo[x].origin_asn)
            }

            var uniqueASNs = asnList.filter(this.onlyUnique)

            var fullDataSet = {datasets: []};
             for (var asnNum = 0; asnNum < uniqueASNs.length; asnNum = asnNum+1) {

                var color = "hsla(" + ~~(360 * Math.random()) + "," +"50%,"+"50%,1)"
                var tempDatasetForGraph =  { 
                    label: uniqueASNs[asnNum],
                    fill: false,
                    borderColor: color, 
                    backgroundColor: color, 
                    pointHitRadius: '4', 
                    pointBorderWidth: '8',
                    pointHoverBorderWidth: '4',
                    data:  []
                }
            
            for (var i = 0; i< disagInfo.length; i = i+1) {
                if (disagInfo[i].origin_asn == uniqueASNs[asnNum]) {
                    var prefixSubnet = null;
                    prefixSubnet = parseInt(disagInfo[i].prefix.split('/')[1])
                    if (prefixSubnet > this.options.scales.yAxes[0].ticks.max) {
                        this.options.scales.yAxes[0].ticks.max = prefixSubnet;
                    }
                    var coodernates = { x:disagInfo[i].observation_time, 
                    y: prefixSubnet, index: disagInfo[i].prefix}

                    
                    if (disagInfo[i].message_type == "A") {
                        disagInfo[i].message_type = "Announcement"
                    } else if (disagInfo[i].message_type == "W") {
                        disagInfo[i].message_type = "Withdrawal"
                    }

                    tempDatasetForGraph.data.push(coodernates)
                   
                    }
            }
            
            fullDataSet.datasets.push(tempDatasetForGraph)
             }

            

            return fullDataSet

        },
        apiresponsechart: async function (prefix) {
            console.log("BEGINNING SEARCH...")
            this.searchedPrefix = prefix;
            this.loading = true;
            this.ShowNoData = false;
            this.ShowGraphAndTableInDOM = false

            this.$store.commit("setSearch", {'disag': prefix})


            try {
                var query = `query DisagHist {
                                getDisaggregationHistory(prefix: "`+prefix+`") {
                                    prefix
                                    peer_asn
                                    observation_time
                                    message_type
                                    origin_asn
                                
                                    }
                                }`
                const disaggHistoryDataRaw = await API.graphql(graphqlOperation(query));
                console.log(disaggHistoryDataRaw)

                var disaggHistoryDataPreCleanse = disaggHistoryDataRaw.data.getDisaggregationHistory;
                console.log(disaggHistoryDataPreCleanse)
                var disaggHistoryData = []
                var cidr;
                for (var i = 0; i< disaggHistoryDataPreCleanse.length; i =i+1) {
                    cidr = parseInt(disaggHistoryDataPreCleanse[i].prefix.split("/")[1])
                    
                    if (cidr > 7) {
                        disaggHistoryData.push(disaggHistoryDataPreCleanse[i])
                    }
                
                }


                var tableData = this.createTableDataForDisAgInfo(disaggHistoryData)

                for (var i = 0; i< disaggHistoryData.length; i =i+1) {
                    var tempDateTime = this.convertEpochtoTimeDate(disaggHistoryData[i].observation_time)
                    disaggHistoryData[i].observation_time =tempDateTime
                    
                    if (!(this.asn_get_owner.includes(disaggHistoryData[i].peer_asn.toString()))) {
                       this.asn_get_owner.push(disaggHistoryData[i].peer_asn.toString())
                    }
                    if (!(this.asn_get_owner.includes(disaggHistoryData[i].origin_asn.toString()))) {
                        this.asn_get_owner.push(disaggHistoryData[i].origin_asn.toString())
                    }

                    disaggHistoryData[i].origin_asn = disaggHistoryData[i].origin_asn.toString()
                    disaggHistoryData[i].peer_asn = disaggHistoryData[i].peer_asn.toString()

                    if (disaggHistoryData[i].message_type == "A") {
                        disaggHistoryData[i].message_type = "Announcement"
                    } else if (disaggHistoryData[i].message_type == "W") {
                        disaggHistoryData[i].message_type = "Withdrawal"
                    }
                    if (i == disaggHistoryData.length - 1) {
                        this.getASNOwners()
                    }
                }

                this.id = this.id +1;
                this.scatdata2 = tableData
                this.disagdata = disaggHistoryData
                
                if (this.disagdata.length > 0) {
                    this.loading = false;
                    this.ShowGraphAndTableInDOM = true
                } else {
                    this.ShowNoData = true
                }
            } catch (err) {
                console.log(err)
                this.loading = false
                this.ShowNoData = true
            }
            
        
        },
        getAnASNOwner: async function(asn) {
            //console.log("getting asn owner: " + asn)
            if (asn == 0 || asn == 'N/A') {
                return "None";
            } else if (asn == 'Restricted Prefix') {
                return "Restricted Prefix"
            } else {
                try {
                    var qry = `query getASNOwner { getASNOwner ( asn: "` +
                    asn +
                    `" ) {
                            organisation
                        }
                    }`;
                    //console.log(qry);
                    const res = await API.graphql(graphqlOperation(qry));
                    var ownData = res.data.getASNOwner;
                    //console.log(ownData);
                    if (ownData) {
                        if (ownData.length > 0) {
                        //console.log("owner: ");
                        //console.log(ownData[0].organisation);
                            if (ownData[0].organisation) {
                                return ownData[0].organisation;
                            } else {
                                return "Unknown";
                            }
                        } else {
                            return "Unknown";
                        }
                    } else {
                        return "Unknown";
                    }
                } catch (err) {
                    console.log(err);
                    return "Unknown";
                }
            }
        },
        getASNOwners: async function () {
            
            console.log("gettign asn owners")
            var nero = {}
            for ( var i = 0 ; i < this.asn_get_owner.length ; i++ ) {
                var keys = Object.keys(this.asn_own_dict)
                if (!(keys.includes((this.asn_get_owner[i]).toString()))) {
                    nero[this.asn_get_owner[i]] = this.getAnASNOwner(this.asn_get_owner[i])
                }
            }
            for ( var i = 0 ; i < this.asn_get_owner.length ; i++ ) {
                
                
                //console.log("GETTING AN OWNER")
                if (!(keys.includes((this.asn_get_owner[i]).toString()))) {
                    this.asn_own_dict[this.asn_get_owner[i]] = await nero[this.asn_get_owner[i]]
                }
                
                if ( i == this.asn_get_owner.length - 1 ) {
                    this.table_buffer = false;
                    this.$nextTick(() => {
                        // Add the component back in
                        this.table_buffer = true;
                    });
                }
            }
        },
        onlyUnique: function (value, index, self) { //returns unique values in a list

            return self.indexOf(value) === index;
        },
        convertEpochtoTimeDate: function (epochTime) {
                try {
                    var d_t = new Date( epochTime *1000);

                var date = d_t.toLocaleString().substr(0, 10);
                var time = d_t.toLocaleString().substr(11, 9);

                var dateTime  = {"date": date, "time": time, "epoch": epochTime}

                return dateTime
                }
                catch(err) {
                    console.log(err)
                }

            }

    }
}
</script>

<style scoped>
    
    tbody tr:nth-of-type(even) {
      background-color: rgba(0, 0, 0, .05);
    }    

</style>